import { Item } from "../types";



/**
 * semplice funzione di ordinamento per valori string
 */
export const sortAscFn = (a: Item, b: Item) => {
	if (typeof a.value == 'number' && typeof b.value == 'number') return a.value - b.value;
	return a.value.localeCompare(b.value);
}

export const sortDescFn = (a: Item, b: Item) => {
	if (typeof a.value == 'number' && typeof b.value == 'number') return b.value - a.value;
	return b.value.localeCompare(a.value);
}

export const SortsFunctions: GroupFunctionType[] = [
	{ id: 1, label: "DESCENDING", fn: sortDescFn },
	{ id: 2, label: "ASCENDING", fn: sortAscFn },
]

export const groupSumFn = (val1: number, val2: number) => {
	if ( val1 == null ) return val2;
	if ( val2 == null ) return val1;
	return val1 + val2
}

export const groupAverangeFn = (value1: any, value2: any) => {
	if (value1 == null) return value2;
	if (value2 == null) return value1;
	return (value1 + value2) / 2;
}

export const groupMaxFn = (val1, val2) => {
	if ( val1 == null ) return val2;
	if ( val2 == null ) return val1;
	return Math.max(val1, val2)
}

export const groupMinFn = (val1, val2) => {
	if ( val1 == null ) return val2;
	if ( val2 == null ) return val1;
	Math.min(val1, val2)
}

export const groupCountFn = (val1, val2) => val1 + 1;

export const groupFirstFn = (val1, val2) => val1;

export const groupLastFn = (val1, val2) => val2;

export const GroupsFunctions: GroupFunctionType[] = [
	{ id: 1, label: "SUM", fn: groupSumFn },
	{ id: 2, label: "AVERAGE", fn: groupAverangeFn },
	{ id: 3, label: "MAX", fn: groupMaxFn },
	{ id: 4, label: "MIN", fn: groupMinFn },
	{ id: 5, label: "COUNT", fn: groupCountFn },
	{ id: 6, label: "FIRST", fn: groupFirstFn },
	{ id: 7, label: "LAST", fn: groupLastFn },
];

export type GroupFunctionType = {
	id: number;
	label: string;
	fn: (val1: any, val2: any) => any;
};
